import { createAction, props } from "@ngrx/store";
import { HeaderCommonStore } from "../interfaces/header-common-store";

export const UpdateCommonHeaderStore = createAction(
  "[Common] Update Common Header Store",
  props<{previousRoute: HeaderCommonStore}>())